// extracted by mini-css-extract-plugin
export default {"container":"BorderedContainer_container__zuoXl"};